import * as React from 'react';
import { memo } from 'react';

const SvgXV2 = (props) => (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m18.75 5.25-13.5 13.5M18.75 18.75 5.25 5.25", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })));
const Memo = memo(SvgXV2);

export { Memo as default };
